import { useQuery } from '@tanstack/react-query';

import { crmApi } from '@/shared/api';
import { queryIds } from '@/shared/utils/constants';
import useNotification from '@/shared/hooks/UseNotification';

type Options = {
  bookyearId?: string;
  buildingId?: string;
  hoaId?: string;
  hoaRelationsOnly?: boolean;
  includeCentralCompanies?: boolean;
  includeCompanies?: boolean;
  includeContacts?: boolean;
  includeTeams?: boolean;
  hasFinancialInfo?: boolean;
  unitId?: string | null;
};

const useGetCrmOptions = ({
  bookyearId,
  buildingId,
  hoaId,
  hoaRelationsOnly,
  includeTeams,
  includeCentralCompanies,
  includeCompanies,
  includeContacts,
  hasFinancialInfo,
  unitId,
}: Options) => {
  const { sendDefaultError } = useNotification();

  const { data, isLoading } = useQuery({
    onError: sendDefaultError,
    queryFn: () =>
      crmApi.getCrmAutocomplete({
        bookyearId,
        buildingId,
        hasFinancialInfo,
        hoaId,
        hoaRelationsOnly,
        includeCentralCompanies,
        includeCompanies,
        includeContacts,
        includeTeams,
        unitId,
      }),
    queryKey: [
      queryIds.crm.GET_OPTIONS,
      buildingId,
      hasFinancialInfo,
      hoaId,
      hoaRelationsOnly,
      includeTeams,
      includeCentralCompanies,
      includeCompanies,
      includeContacts,
      unitId,
    ],
  });

  return {
    areCrmOptionsLoading: isLoading,
    crmOptions: data,
  };
};

export default useGetCrmOptions;
